// USDA Food Database

export const foodsDatabaseUSDA = [
  // ==================== FRUITS (30 items) ====================
  {
    name: 'Apple',
    category: 'Fruits',
    oz: 5.3,
    cal: 95,
    protein: 0.5,
    carbs: 25,
    fat: 0.3,
  },
  {
    name: 'Banana',
    category: 'Fruits',
    oz: 3.5,
    cal: 105,
    protein: 1.3,
    carbs: 27,
    fat: 0.3,
  },
  {
    name: 'Orange',
    category: 'Fruits',
    oz: 5.2,
    cal: 62,
    protein: 1.2,
    carbs: 15,
    fat: 0.3,
  },
  {
    name: 'Strawberry',
    category: 'Fruits',
    oz: 5,
    cal: 32,
    protein: 0.8,
    carbs: 7.7,
    fat: 0.3,
  },
  {
    name: 'Blueberry',
    category: 'Fruits',
    oz: 5.3,
    cal: 57,
    protein: 0.7,
    carbs: 14,
    fat: 0.3,
  },
  {
    name: 'Grape (seedless)',
    category: 'Fruits',
    oz: 3.2,
    cal: 54,
    protein: 0.5,
    carbs: 14,
    fat: 0.2,
  },
  {
    name: 'Watermelon',
    category: 'Fruits',
    oz: 5.3,
    cal: 30,
    protein: 0.6,
    carbs: 7.6,
    fat: 0.2,
  },
  {
    name: 'Mango',
    category: 'Fruits',
    oz: 3.5,
    cal: 60,
    protein: 0.8,
    carbs: 15,
    fat: 0.4,
  },
  {
    name: 'Pineapple',
    category: 'Fruits',
    oz: 5.6,
    cal: 50,
    protein: 0.5,
    carbs: 13,
    fat: 0.1,
  },
  {
    name: 'Peach',
    category: 'Fruits',
    oz: 5.3,
    cal: 39,
    protein: 0.9,
    carbs: 9.5,
    fat: 0.3,
  },
  {
    name: 'Pear',
    category: 'Fruits',
    oz: 6.2,
    cal: 57,
    protein: 0.4,
    carbs: 15,
    fat: 0.2,
  },
  {
    name: 'Blackberry',
    category: 'Fruits',
    oz: 5.3,
    cal: 43,
    protein: 0.9,
    carbs: 10,
    fat: 0.5,
  },
  {
    name: 'Raspberry',
    category: 'Fruits',
    oz: 4,
    cal: 32,
    protein: 0.8,
    carbs: 7.4,
    fat: 0.5,
  },
  {
    name: 'Cantaloupe',
    category: 'Fruits',
    oz: 5.3,
    cal: 34,
    protein: 0.8,
    carbs: 8,
    fat: 0.3,
  },
  {
    name: 'Honeydew',
    category: 'Fruits',
    oz: 5.3,
    cal: 36,
    protein: 0.6,
    carbs: 9,
    fat: 0.1,
  },
  {
    name: 'Grapefruit',
    category: 'Fruits',
    oz: 5.3,
    cal: 41,
    protein: 0.8,
    carbs: 10,
    fat: 0.1,
  },
  {
    name: 'Tangerine',
    category: 'Fruits',
    oz: 3.8,
    cal: 47,
    protein: 0.7,
    carbs: 12,
    fat: 0.3,
  },
  {
    name: 'Plum',
    category: 'Fruits',
    oz: 2.3,
    cal: 30,
    protein: 0.5,
    carbs: 7,
    fat: 0.2,
  },
  {
    name: 'Cherry',
    category: 'Fruits',
    oz: 3.6,
    cal: 52,
    protein: 0.8,
    carbs: 12,
    fat: 0.3,
  },
  {
    name: 'Pomegranate',
    category: 'Fruits',
    oz: 2,
    cal: 30,
    protein: 0.6,
    carbs: 7,
    fat: 0.3,
  },
  {
    name: 'Date (Medjool)',
    category: 'Fruits',
    oz: 0.8,
    cal: 66,
    protein: 0.4,
    carbs: 18,
    fat: 0.1,
  },
  {
    name: 'Dried Apricot',
    category: 'Fruits',
    oz: 0.3,
    cal: 67,
    protein: 0.9,
    carbs: 17,
    fat: 0.2,
  },
  {
    name: 'Raisin',
    category: 'Fruits',
    oz: 0.5,
    cal: 86,
    protein: 1.1,
    carbs: 23,
    fat: 0.2,
  },
  {
    name: 'Lime',
    category: 'Fruits',
    oz: 1,
    cal: 11,
    protein: 0.4,
    carbs: 3.7,
    fat: 0.1,
  },
  {
    name: 'Lemon',
    category: 'Fruits',
    oz: 1.6,
    cal: 17,
    protein: 0.6,
    carbs: 5.4,
    fat: 0.2,
  },
  {
    name: 'Passion Fruit',
    category: 'Fruits',
    oz: 0.6,
    cal: 18,
    protein: 0.4,
    carbs: 4,
    fat: 0.1,
  },
  {
    name: 'Dragon Fruit (White)',
    category: 'Fruits',
    oz: 6,
    cal: 60,
    protein: 1.2,
    carbs: 13,
    fat: 0.4,
  },
  {
    name: 'Kiwi Fruit',
    category: 'Fruits',
    oz: 2.8,
    cal: 42,
    protein: 0.8,
    carbs: 10,
    fat: 0.4,
  },
  {
    name: 'Guava',
    category: 'Fruits',
    oz: 3.2,
    cal: 37,
    protein: 0.7,
    carbs: 8,
    fat: 0.6,
  },
  {
    name: 'Lychee',
    category: 'Fruits',
    oz: 0.6,
    cal: 18,
    protein: 0.2,
    carbs: 4.5,
    fat: 0.1,
  },

  // ==================== VEGETABLES (35 items) ====================
  {
    name: 'Broccoli',
    category: 'Vegetables',
    oz: 3.1,
    cal: 34,
    protein: 2.8,
    carbs: 7,
    fat: 0.4,
  },
  {
    name: 'Carrot',
    category: 'Vegetables',
    oz: 2.5,
    cal: 26,
    protein: 0.6,
    carbs: 6,
    fat: 0.2,
  },
  {
    name: 'Spinach (raw)',
    category: 'Vegetables',
    oz: 1,
    cal: 7,
    protein: 0.9,
    carbs: 1.1,
    fat: 0.1,
  },
  {
    name: 'Tomato',
    category: 'Vegetables',
    oz: 5.3,
    cal: 27,
    protein: 1.3,
    carbs: 5.8,
    fat: 0.3,
  },
  {
    name: 'Lettuce (Iceberg)',
    category: 'Vegetables',
    oz: 1.6,
    cal: 5,
    protein: 0.5,
    carbs: 0.9,
    fat: 0.1,
  },
  {
    name: 'Lettuce (Romaine)',
    category: 'Vegetables',
    oz: 1.9,
    cal: 8,
    protein: 0.6,
    carbs: 1.5,
    fat: 0.1,
  },
  {
    name: 'Cucumber',
    category: 'Vegetables',
    oz: 3.5,
    cal: 16,
    protein: 0.8,
    carbs: 3.6,
    fat: 0.2,
  },
  {
    name: 'Onion',
    category: 'Vegetables',
    oz: 1,
    cal: 11,
    protein: 0.3,
    carbs: 2.5,
    fat: 0.1,
  },
  {
    name: 'Garlic',
    category: 'Vegetables',
    oz: 0.1,
    cal: 4,
    protein: 0.2,
    carbs: 1,
    fat: 0,
  },
  {
    name: 'Bell Pepper (Red)',
    category: 'Vegetables',
    oz: 3.2,
    cal: 37,
    protein: 1.2,
    carbs: 9,
    fat: 0.4,
  },
  {
    name: 'Bell Pepper (Green)',
    category: 'Vegetables',
    oz: 3.2,
    cal: 30,
    protein: 1,
    carbs: 7,
    fat: 0.3,
  },
  {
    name: 'Potato (Cooked)',
    category: 'Vegetables',
    oz: 5.3,
    cal: 103,
    protein: 2.1,
    carbs: 17,
    fat: 0.1,
  },
  {
    name: 'Sweet Potato (Cooked)',
    category: 'Vegetables',
    oz: 5.3,
    cal: 103,
    protein: 2,
    carbs: 24,
    fat: 0.1,
  },
  {
    name: 'Cabbage (Raw)',
    category: 'Vegetables',
    oz: 1.2,
    cal: 8,
    protein: 0.4,
    carbs: 1.8,
    fat: 0.1,
  },
  {
    name: 'Cauliflower (Raw)',
    category: 'Vegetables',
    oz: 1.2,
    cal: 6,
    protein: 0.5,
    carbs: 1.1,
    fat: 0.1,
  },
  {
    name: 'Green Beans',
    category: 'Vegetables',
    oz: 2.8,
    cal: 19,
    protein: 1.1,
    carbs: 4.2,
    fat: 0.2,
  },
  {
    name: 'Peas (Green)',
    category: 'Vegetables',
    oz: 2.8,
    cal: 38,
    protein: 2.8,
    carbs: 7,
    fat: 0.2,
  },
  {
    name: 'Corn (Kernels)',
    category: 'Vegetables',
    oz: 3.4,
    cal: 35,
    protein: 1.3,
    carbs: 8,
    fat: 0.5,
  },
  {
    name: 'Celery',
    category: 'Vegetables',
    oz: 1.4,
    cal: 6,
    protein: 0.3,
    carbs: 1.2,
    fat: 0.1,
  },
  {
    name: 'Mushroom (White)',
    category: 'Vegetables',
    oz: 0.7,
    cal: 3,
    protein: 0.4,
    carbs: 0.5,
    fat: 0,
  },
  {
    name: 'Zucchini',
    category: 'Vegetables',
    oz: 3.5,
    cal: 19,
    protein: 1.5,
    carbs: 3.5,
    fat: 0.4,
  },
  {
    name: 'Asparagus',
    category: 'Vegetables',
    oz: 2.1,
    cal: 20,
    protein: 2.2,
    carbs: 3.7,
    fat: 0.1,
  },
  {
    name: 'Beet (Cooked)',
    category: 'Vegetables',
    oz: 3.5,
    cal: 44,
    protein: 1.7,
    carbs: 10,
    fat: 0.2,
  },
  {
    name: 'Radish (Raw)',
    category: 'Vegetables',
    oz: 1,
    cal: 4,
    protein: 0.2,
    carbs: 0.9,
    fat: 0.1,
  },
  {
    name: 'Eggplant (Raw)',
    category: 'Vegetables',
    oz: 1.2,
    cal: 5,
    protein: 0.2,
    carbs: 1.2,
    fat: 0.1,
  },
  {
    name: 'Pumpkin (Cooked)',
    category: 'Vegetables',
    oz: 4.9,
    cal: 42,
    protein: 1,
    carbs: 10,
    fat: 0.1,
  },
  {
    name: 'Kale (Raw)',
    category: 'Vegetables',
    oz: 1,
    cal: 7,
    protein: 0.7,
    carbs: 1.3,
    fat: 0.1,
  },
  {
    name: 'Collard Greens (Cooked)',
    category: 'Vegetables',
    oz: 3.5,
    cal: 35,
    protein: 2.7,
    carbs: 6,
    fat: 0.5,
  },
  {
    name: 'Mustard Greens (Cooked)',
    category: 'Vegetables',
    oz: 3.5,
    cal: 21,
    protein: 1.6,
    carbs: 3.7,
    fat: 0.3,
  },
  {
    name: 'Bok Choy (Raw)',
    category: 'Vegetables',
    oz: 0.7,
    cal: 3,
    protein: 0.4,
    carbs: 0.6,
    fat: 0,
  },
  {
    name: 'Okra',
    category: 'Vegetables',
    oz: 0.9,
    cal: 7,
    protein: 0.5,
    carbs: 1.5,
    fat: 0.1,
  },
  {
    name: 'Acorn Squash (Cooked)',
    category: 'Vegetables',
    oz: 3.2,
    cal: 57,
    protein: 1.1,
    carbs: 15,
    fat: 0.1,
  },
  {
    name: 'Turnip (Cooked)',
    category: 'Vegetables',
    oz: 3.5,
    cal: 18,
    protein: 0.6,
    carbs: 4,
    fat: 0.1,
  },
  {
    name: 'Rutabaga (Cooked)',
    category: 'Vegetables',
    oz: 3.5,
    cal: 33,
    protein: 1.1,
    carbs: 7.4,
    fat: 0.2,
  },
  {
    name: 'Parsnip (Cooked)',
    category: 'Vegetables',
    oz: 3.5,
    cal: 55,
    protein: 1,
    carbs: 13,
    fat: 0.2,
  },
  {
    name: 'Fennel (Raw)',
    category: 'Vegetables',
    oz: 2.6,
    cal: 15,
    protein: 0.7,
    carbs: 3.5,
    fat: 0.2,
  },
  {
    name: 'Leek (Cooked)',
    category: 'Vegetables',
    oz: 2.5,
    cal: 18,
    protein: 0.4,
    carbs: 4,
    fat: 0.1,
  },

  // ==================== PROTEINS (50+ items) ====================
  {
    name: 'Chicken Breast (Skinless, Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 165,
    protein: 31,
    carbs: 0,
    fat: 3.6,
  },
  {
    name: 'Ground Beef (93% Lean)',
    category: 'Proteins',
    oz: 3.5,
    cal: 180,
    protein: 24,
    carbs: 0,
    fat: 8.7,
  },
  {
    name: 'Beef Steak (Sirloin, Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 260,
    protein: 26,
    carbs: 0,
    fat: 17,
  },
  {
    name: 'Salmon (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 280,
    protein: 25,
    carbs: 0,
    fat: 20,
  },
  {
    name: 'Turkey Breast (Skinless)',
    category: 'Proteins',
    oz: 3.5,
    cal: 135,
    protein: 29,
    carbs: 0,
    fat: 0.7,
  },
  {
    name: 'Duck (Roasted, Skin Removed)',
    category: 'Proteins',
    oz: 3.5,
    cal: 201,
    protein: 27,
    carbs: 0,
    fat: 10,
  },
  {
    name: 'Pork Chop (Lean, Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 242,
    protein: 27,
    carbs: 0,
    fat: 14,
  },
  {
    name: 'Lamb (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 294,
    protein: 25,
    carbs: 0,
    fat: 21,
  },
  {
    name: 'Veal (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 215,
    protein: 28,
    carbs: 0,
    fat: 11,
  },
  {
    name: 'Venison (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 158,
    protein: 30,
    carbs: 0,
    fat: 3.2,
  },
  {
    name: 'Bison (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 148,
    protein: 28,
    carbs: 0,
    fat: 3.4,
  },
  {
    name: 'Tilapia (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 128,
    protein: 26,
    carbs: 0,
    fat: 2.7,
  },
  {
    name: 'Trout (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 208,
    protein: 23,
    carbs: 0,
    fat: 12,
  },
  {
    name: 'Halibut (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 140,
    protein: 27,
    carbs: 0,
    fat: 3,
  },
  {
    name: 'Mahi Mahi (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 130,
    protein: 28,
    carbs: 0,
    fat: 1.3,
  },
  {
    name: 'Mackerel (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 262,
    protein: 24,
    carbs: 0,
    fat: 18,
  },
  {
    name: 'Sardine (Canned in Oil)',
    category: 'Proteins',
    oz: 1.8,
    cal: 60,
    protein: 7,
    carbs: 0,
    fat: 3.3,
  },
  {
    name: 'Crab (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 102,
    protein: 20,
    carbs: 0,
    fat: 1.7,
  },
  {
    name: 'Lobster (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 112,
    protein: 24,
    carbs: 1.3,
    fat: 0.5,
  },
  {
    name: 'Oyster (Cooked)',
    category: 'Proteins',
    oz: 1,
    cal: 13,
    protein: 1.5,
    carbs: 0.5,
    fat: 0.4,
  },
  {
    name: 'Mussel (Cooked)',
    category: 'Proteins',
    oz: 1,
    cal: 17,
    protein: 2.3,
    carbs: 0.7,
    fat: 0.4,
  },
  {
    name: 'Clam (Cooked)',
    category: 'Proteins',
    oz: 1,
    cal: 17,
    protein: 3,
    carbs: 0.6,
    fat: 0.2,
  },
  {
    name: 'Squid (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 158,
    protein: 28,
    carbs: 7,
    fat: 2,
  },
  {
    name: 'Scallop (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 112,
    protein: 21,
    carbs: 2,
    fat: 1.5,
  },
  {
    name: 'Bacon (Cooked)',
    category: 'Proteins',
    oz: 0.5,
    cal: 86,
    protein: 6,
    carbs: 0,
    fat: 7,
  },
  {
    name: 'Ham (Cooked)',
    category: 'Proteins',
    oz: 1,
    cal: 32,
    protein: 5,
    carbs: 0,
    fat: 1.5,
  },
  {
    name: 'Turkey Bacon (Cooked)',
    category: 'Proteins',
    oz: 0.5,
    cal: 45,
    protein: 5.5,
    carbs: 0,
    fat: 2.5,
  },
  {
    name: 'Sausage (Pork, Cooked)',
    category: 'Proteins',
    oz: 1.4,
    cal: 96,
    protein: 11,
    carbs: 0.5,
    fat: 5.2,
  },
  {
    name: 'Hot Dog (Beef)',
    category: 'Proteins',
    oz: 1.8,
    cal: 155,
    protein: 5.5,
    carbs: 2,
    fat: 14,
  },
  {
    name: 'Egg (Large, Boiled)',
    category: 'Proteins',
    oz: 1.8,
    cal: 78,
    protein: 6.3,
    carbs: 0.6,
    fat: 5.3,
  },
  {
    name: 'Egg White (Large)',
    category: 'Proteins',
    oz: 1.2,
    cal: 17,
    protein: 3.6,
    carbs: 0.4,
    fat: 0,
  },
  {
    name: 'Tofu (Firm)',
    category: 'Proteins',
    oz: 3.5,
    cal: 76,
    protein: 8.1,
    carbs: 1.9,
    fat: 4.8,
  },
  {
    name: 'Tempeh',
    category: 'Proteins',
    oz: 3.5,
    cal: 193,
    protein: 19,
    carbs: 7.6,
    fat: 11,
  },
  {
    name: 'Chicken Thigh (Skinless)',
    category: 'Proteins',
    oz: 3.5,
    cal: 209,
    protein: 26,
    carbs: 0,
    fat: 11,
  },
  {
    name: 'Turkey Ground (93% Lean)',
    category: 'Proteins',
    oz: 3.5,
    cal: 150,
    protein: 28,
    carbs: 0,
    fat: 3.2,
  },
  {
    name: 'Beef Ground (80% Lean)',
    category: 'Proteins',
    oz: 3.5,
    cal: 254,
    protein: 19,
    carbs: 0,
    fat: 20,
  },
  {
    name: 'Tuna (Canned in Water)',
    category: 'Proteins',
    oz: 2.8,
    cal: 52,
    protein: 11,
    carbs: 0,
    fat: 0.4,
  },
  {
    name: 'Cod (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 105,
    protein: 23,
    carbs: 0,
    fat: 0.9,
  },
  {
    name: 'Catfish (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 193,
    protein: 21,
    carbs: 0,
    fat: 11,
  },
  {
    name: 'Snapper (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 128,
    protein: 26,
    carbs: 0,
    fat: 1.7,
  },
  {
    name: 'Pollock (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 105,
    protein: 23,
    carbs: 0,
    fat: 0.8,
  },
  {
    name: 'Shrimp (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 99,
    protein: 24,
    carbs: 0,
    fat: 0.3,
  },
  {
    name: 'Ground Lamb',
    category: 'Proteins',
    oz: 3.5,
    cal: 347,
    protein: 24,
    carbs: 0,
    fat: 28,
  },
  {
    name: 'Beef Liver (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 175,
    protein: 26,
    carbs: 5,
    fat: 5,
  },
  {
    name: 'Chicken Liver (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 188,
    protein: 27,
    carbs: 0.3,
    fat: 8.5,
  },
  {
    name: 'Beef Ground (Lean)',
    category: 'Proteins',
    oz: 3.5,
    cal: 203,
    protein: 23,
    carbs: 0,
    fat: 12,
  },
  {
    name: 'Pork Loin (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 209,
    protein: 29,
    carbs: 0,
    fat: 9.7,
  },
  {
    name: 'Flounder (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 104,
    protein: 22,
    carbs: 0,
    fat: 1.3,
  },
  {
    name: 'Haddock (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 112,
    protein: 24,
    carbs: 0,
    fat: 0.8,
  },
  {
    name: 'Sea Bass (Cooked)',
    category: 'Proteins',
    oz: 3.5,
    cal: 97,
    protein: 21,
    carbs: 0,
    fat: 1.3,
  },

  // ==================== DAIRY (20 items) ====================
  {
    name: 'Milk (Whole)',
    category: 'Dairy',
    oz: 8,
    cal: 150,
    protein: 8,
    carbs: 12,
    fat: 8,
  },
  {
    name: 'Milk (2%)',
    category: 'Dairy',
    oz: 8,
    cal: 122,
    protein: 8,
    carbs: 12,
    fat: 5,
  },
  {
    name: 'Milk (Skim)',
    category: 'Dairy',
    oz: 8,
    cal: 86,
    protein: 8,
    carbs: 12,
    fat: 0.4,
  },
  {
    name: 'Greek Yogurt (Plain, Nonfat)',
    category: 'Dairy',
    oz: 5.3,
    cal: 59,
    protein: 10,
    carbs: 3.3,
    fat: 0.1,
  },
  {
    name: 'Greek Yogurt (Plain, Full Fat)',
    category: 'Dairy',
    oz: 5.3,
    cal: 100,
    protein: 17,
    carbs: 3.6,
    fat: 5,
  },
  {
    name: 'Cheddar Cheese',
    category: 'Dairy',
    oz: 1,
    cal: 115,
    protein: 7,
    carbs: 0.4,
    fat: 9.4,
  },
  {
    name: 'Mozzarella Cheese',
    category: 'Dairy',
    oz: 1,
    cal: 85,
    protein: 6.3,
    carbs: 0.6,
    fat: 6.3,
  },
  {
    name: 'Cottage Cheese (Low Fat)',
    category: 'Dairy',
    oz: 4,
    cal: 44,
    protein: 7,
    carbs: 1.5,
    fat: 0.8,
  },
  {
    name: 'Cream Cheese',
    category: 'Dairy',
    oz: 0.5,
    cal: 50,
    protein: 0.9,
    carbs: 0.8,
    fat: 5,
  },
  {
    name: 'Ricotta Cheese (Part Skim)',
    category: 'Dairy',
    oz: 2,
    cal: 39,
    protein: 3.3,
    carbs: 1.5,
    fat: 2.2,
  },
  {
    name: 'Goat Cheese',
    category: 'Dairy',
    oz: 1,
    cal: 103,
    protein: 5.9,
    carbs: 0.2,
    fat: 8.5,
  },
  {
    name: 'Feta Cheese',
    category: 'Dairy',
    oz: 1,
    cal: 75,
    protein: 4.2,
    carbs: 1.2,
    fat: 6,
  },
  {
    name: 'Blue Cheese',
    category: 'Dairy',
    oz: 1,
    cal: 100,
    protein: 6,
    carbs: 0.7,
    fat: 8.2,
  },
  {
    name: 'Swiss Cheese',
    category: 'Dairy',
    oz: 1,
    cal: 108,
    protein: 8,
    carbs: 1.5,
    fat: 8,
  },
  {
    name: 'Provolone Cheese',
    category: 'Dairy',
    oz: 1,
    cal: 100,
    protein: 7.3,
    carbs: 0.6,
    fat: 7.6,
  },
  {
    name: 'Parmesan Cheese',
    category: 'Dairy',
    oz: 1,
    cal: 110,
    protein: 10,
    carbs: 1,
    fat: 7,
  },
  {
    name: 'Brie Cheese',
    category: 'Dairy',
    oz: 1,
    cal: 95,
    protein: 4.9,
    carbs: 0.1,
    fat: 7.9,
  },
  {
    name: 'Camembert Cheese',
    category: 'Dairy',
    oz: 1,
    cal: 85,
    protein: 5.6,
    carbs: 0.5,
    fat: 6.8,
  },
  {
    name: 'Yogurt (Plain, Nonfat)',
    category: 'Dairy',
    oz: 5.3,
    cal: 63,
    protein: 5.3,
    carbs: 7.2,
    fat: 0.2,
  },
  {
    name: 'Yogurt (Plain, Whole Milk)',
    category: 'Dairy',
    oz: 5.3,
    cal: 100,
    protein: 3.5,
    carbs: 3.6,
    fat: 5.4,
  },

  // ==================== GRAINS (25 items) ====================
  {
    name: 'White Rice (Cooked)',
    category: 'Grains',
    oz: 5.6,
    cal: 206,
    protein: 4.3,
    carbs: 45,
    fat: 0.2,
  },
  {
    name: 'Brown Rice (Cooked)',
    category: 'Grains',
    oz: 5.6,
    cal: 215,
    protein: 5,
    carbs: 45,
    fat: 1.8,
  },
  {
    name: 'Whole Wheat Bread (1 slice)',
    category: 'Grains',
    oz: 1.2,
    cal: 100,
    protein: 3.6,
    carbs: 18,
    fat: 1.5,
  },
  {
    name: 'White Bread (1 slice)',
    category: 'Grains',
    oz: 1.2,
    cal: 79,
    protein: 2.7,
    carbs: 15,
    fat: 1,
  },
  {
    name: 'Oatmeal (Cooked)',
    category: 'Grains',
    oz: 4.9,
    cal: 150,
    protein: 5,
    carbs: 27,
    fat: 3,
  },
  {
    name: 'Pasta (Cooked, Whole Wheat)',
    category: 'Grains',
    oz: 5.6,
    cal: 194,
    protein: 8.4,
    carbs: 37,
    fat: 0.9,
  },
  {
    name: 'Pasta (Cooked, White)',
    category: 'Grains',
    oz: 5.6,
    cal: 220,
    protein: 8.1,
    carbs: 43,
    fat: 1.2,
  },
  {
    name: 'Rye Bread (1 slice)',
    category: 'Grains',
    oz: 1.2,
    cal: 83,
    protein: 2.7,
    carbs: 16,
    fat: 1.1,
  },
  {
    name: 'Sourdough Bread (1 slice)',
    category: 'Grains',
    oz: 1.2,
    cal: 87,
    protein: 3.2,
    carbs: 17,
    fat: 0.6,
  },
  {
    name: 'Quinoa (Cooked)',
    category: 'Grains',
    oz: 5.6,
    cal: 222,
    protein: 8.1,
    carbs: 39,
    fat: 3.9,
  },
  {
    name: 'Barley (Cooked)',
    category: 'Grains',
    oz: 5.6,
    cal: 193,
    protein: 3.6,
    carbs: 44,
    fat: 0.8,
  },
  {
    name: 'Millet (Cooked)',
    category: 'Grains',
    oz: 5.6,
    cal: 207,
    protein: 6.3,
    carbs: 41,
    fat: 1.7,
  },
  {
    name: 'Amaranth (Cooked)',
    category: 'Grains',
    oz: 5.6,
    cal: 251,
    protein: 9.3,
    carbs: 46,
    fat: 5.2,
  },
  {
    name: 'Buckwheat (Cooked)',
    category: 'Grains',
    oz: 5.6,
    cal: 155,
    protein: 5.7,
    carbs: 33,
    fat: 1,
  },
  {
    name: 'Couscous (Cooked)',
    category: 'Grains',
    oz: 5.6,
    cal: 176,
    protein: 5.9,
    carbs: 36,
    fat: 0.3,
  },
  {
    name: 'Cereal (Generic Corn Flakes, 1 cup)',
    category: 'Grains',
    oz: 1,
    cal: 100,
    protein: 2,
    carbs: 24,
    fat: 0.3,
  },
  {
    name: 'Granola (1/4 cup)',
    category: 'Grains',
    oz: 1.4,
    cal: 180,
    protein: 4,
    carbs: 24,
    fat: 9,
  },
  {
    name: 'Polenta (Cooked)',
    category: 'Grains',
    oz: 5.3,
    cal: 71,
    protein: 1.5,
    carbs: 16,
    fat: 0.3,
  },
  {
    name: 'Farro (Cooked)',
    category: 'Grains',
    oz: 5.6,
    cal: 200,
    protein: 7,
    carbs: 37,
    fat: 1.1,
  },
  {
    name: 'Spelt (Cooked)',
    category: 'Grains',
    oz: 5.6,
    cal: 246,
    protein: 10.7,
    carbs: 43,
    fat: 1.7,
  },
  {
    name: 'Teff (Cooked)',
    category: 'Grains',
    oz: 5.6,
    cal: 185,
    protein: 6.9,
    carbs: 33,
    fat: 0.7,
  },
  {
    name: 'Sorghum (Cooked)',
    category: 'Grains',
    oz: 5.6,
    cal: 224,
    protein: 7.3,
    carbs: 41,
    fat: 2.3,
  },
  {
    name: 'Wheat Berry (Cooked)',
    category: 'Grains',
    oz: 5.6,
    cal: 246,
    protein: 8.9,
    carbs: 41,
    fat: 1.7,
  },
  {
    name: 'Rye Grain (Cooked)',
    category: 'Grains',
    oz: 5.6,
    cal: 189,
    protein: 6,
    carbs: 34,
    fat: 1.3,
  },
  {
    name: 'Kasha (Buckwheat Groats)',
    category: 'Grains',
    oz: 5.6,
    cal: 155,
    protein: 5.7,
    carbs: 33,
    fat: 1,
  },

  // ==================== NUTS & SEEDS (15 items) ====================
  {
    name: 'Almonds',
    category: 'Nuts',
    oz: 1,
    cal: 164,
    protein: 6,
    carbs: 6.1,
    fat: 14,
  },
  {
    name: 'Peanuts',
    category: 'Nuts',
    oz: 1,
    cal: 161,
    protein: 7.3,
    carbs: 5.7,
    fat: 14,
  },
  {
    name: 'Walnuts',
    category: 'Nuts',
    oz: 1,
    cal: 185,
    protein: 4.3,
    carbs: 3.9,
    fat: 18.5,
  },
  {
    name: 'Cashews',
    category: 'Nuts',
    oz: 1,
    cal: 155,
    protein: 5,
    carbs: 8.6,
    fat: 12,
  },
  {
    name: 'Brazil Nuts',
    category: 'Nuts',
    oz: 1,
    cal: 187,
    protein: 4,
    carbs: 3,
    fat: 18.8,
  },
  {
    name: 'Pecans',
    category: 'Nuts',
    oz: 1,
    cal: 196,
    protein: 2.6,
    carbs: 3.9,
    fat: 20,
  },
  {
    name: 'Macadamia Nuts',
    category: 'Nuts',
    oz: 1,
    cal: 204,
    protein: 2.2,
    carbs: 3.9,
    fat: 21.5,
  },
  {
    name: 'Hazelnuts',
    category: 'Nuts',
    oz: 1,
    cal: 178,
    protein: 4.2,
    carbs: 4.7,
    fat: 17,
  },
  {
    name: 'Sesame Seeds',
    category: 'Nuts',
    oz: 0.28,
    cal: 52,
    protein: 1.7,
    carbs: 2.2,
    fat: 4.7,
  },
  {
    name: 'Flax Seeds',
    category: 'Nuts',
    oz: 0.35,
    cal: 55,
    protein: 1.9,
    carbs: 2.8,
    fat: 4.3,
  },
  {
    name: 'Hemp Seeds',
    category: 'Nuts',
    oz: 0.5,
    cal: 161,
    protein: 9.2,
    carbs: 2.6,
    fat: 12,
  },
  {
    name: 'Pumpkin Seeds',
    category: 'Nuts',
    oz: 1,
    cal: 180,
    protein: 9,
    carbs: 3.5,
    fat: 16,
  },
  {
    name: 'Sunflower Seeds',
    category: 'Nuts',
    oz: 1,
    cal: 165,
    protein: 5.5,
    carbs: 6.5,
    fat: 14,
  },
  {
    name: 'Pine Nuts',
    category: 'Nuts',
    oz: 0.5,
    cal: 95,
    protein: 3.9,
    carbs: 3.6,
    fat: 9.7,
  },
  {
    name: 'Chestnut',
    category: 'Nuts',
    oz: 1,
    cal: 56,
    protein: 0.8,
    carbs: 12,
    fat: 0.6,
  },
];
